import { createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';

export type PinnedModuleState = {
  module: string,
  isPinned: boolean,
}

export type SidebarState = {
  quickLinks: Array<any>;
  reportsLinks: Array<any>;
  helpLinks: Array<any>;
  supportLinks: Array<any>;
  currentModules: Array<any>;
  pinnedModules: Array<PinnedModuleState>;
  currentModule: string | null;
  currentMenu: string;
  navData: Array<MainMenuItem> | null;
};

export type MainMenuItem = {
  click: () => void;
  icon: string;
  id: string;
  label: string;
  link: string;
  stateVariables: boolean;
  isHeader: boolean;
  subItems: Array<SubMenuItem>;
}

export type SubMenuItem = {
  id: string;
  label: string;
  link: string;
  parentId: string;
}

const initialState: SidebarState = {
  quickLinks: [],
  reportsLinks: [],
  helpLinks: [],
  supportLinks: [],
  currentModules: [],
  pinnedModules: [],
  currentModule: null,
  currentMenu: 'Modules',
  navData: null,
};

const sidebarSlice = createSlice({
  name: 'sidebar',
  initialState,
  reducers: {
    setQuickLinks(state, action) {
      state.quickLinks = action.payload;
    },
    setReportsLinks(state, action) {
      state.reportsLinks = action.payload;
    },
    setHelpLinks(state, action) {
      state.helpLinks = action.payload;
    },
    setSupportLinks(state, action) {
      state.supportLinks = action.payload;
    },
    setCurrentModules(state, action) {
      state.currentModules = action.payload;
    },
    setPinnedModulesState(state, action) {
      if (state.pinnedModules.length >= 6) {
        toast.error('You can only pin 6 modules');
      } else {
        state.pinnedModules = [
          ...state.pinnedModules,
          {module: action.payload, isPinned: true},
        ];
      }
    },
    setUnpinnedModules(state, action) {
      state.pinnedModules = state.pinnedModules.filter(
        (item) => item.module !== action.payload
      );
    },
    setCurrentModule(state, action) {
      state.currentModule = action.payload;
    },
    setCurrentMenu(state, action) {
      state.currentMenu = action.payload;
    },
    setNavData(state, action) {
      state.navData = action.payload;
    },
  },
});

export const {
  setQuickLinks,
  setReportsLinks,
  setHelpLinks,
  setSupportLinks,
  setCurrentModules,
  setPinnedModulesState,
  setUnpinnedModules,
  setCurrentModule,
  setCurrentMenu,
  setNavData,
} = sidebarSlice.actions;

export default sidebarSlice.reducer;
